import { markInputRule, markPasteRule } from '@tiptap/core';
import { Highlight } from '@tiptap/extension-highlight';

/* Regexes are slightly modified versions from the original ones in the @tiptap/extension-highlight package. */

/**
 * Matches a highlight to a ==highlight== on input. Does not allow whitespace at the start or end of the text.
 */
const inputRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(==([^=\s][^=]*[^=\s]|[^=\s])==)$/;

/**
 * Matches a highlight to a ==highlight== on paste. Does not allow whitespace at the start or end of the text.
 */
const pasteRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(==([^=\s][^=]*[^=\s]|[^=\s])==)/g;

export const ZyHighlight = Highlight.extend({
    addInputRules() {
        return [
            markInputRule({
                find: inputRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },

    addPasteRules() {
        return [
            markPasteRule({
                find: pasteRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },
});
